<template>
  <div class="pagenations">
    <el-pagination
        class="pageNations"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 50]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
    </el-pagination>
  </div>
</template>

<script>
  export default {
    name: 'pagenations',
    props:{
      total: {
        type: Number,
        default: 0
      },
      size: {
        type: Number,
        default: 10
      },
      currentPage: {
        type: Number,
        default: 1
      },
    },
    data() {
      return {
        // currentPage: 1,
      }
    },
    mounted() {

    },
    methods: {
      handleSizeChange(val) {
        this.$emit("pageHandler",{"type":'sizeChange',"val":val})
      },
      handleCurrentChange(val) {
        this.$emit("pageHandler",{"type":'currentChange',"val":val})
      }
    }
  }
</script>

<style lang="scss">
.pagenations{
  text-align: right;
  padding-top: 22px;
}
</style>
